import { FaCar, FaTicketAlt, FaChartLine, FaUsers, FaHandshake, FaMoneyBill, FaGlobe, FaExchangeAlt, FaIdCard, FaUserTie, FaTags, FaUserFriends, FaCog, FaClipboardList, FaFileInvoice } from "react-icons/fa";

export const tabs = [
  { id: "cars", name: "Cars", icon: FaCar },
  { id: "rentals", name: "Rentals", icon: FaTicketAlt },
  { id: "customers", name: "Customers", icon: FaUserFriends },
  { id: "availability", name: "Rental Availability", icon: FaChartLine },
  { id: "handovers", name: "Handovers", icon: FaClipboardList },
  { id: "oxygenInvoices", name: "Invoices/Receipts", icon: FaFileInvoice },
  { id: "transfers", name: "Transfers", icon: FaExchangeAlt },
  { id: "transferPricing", name: "Transfer Pricing", icon: FaTags },
  { id: "tours", name: "Tours", icon: FaGlobe },
  { id: "drivers", name: "Drivers", icon: FaUserTie },
  { id: "employees", name: "Employees", icon: FaIdCard },
  { id: "finances", name: "Finances", icon: FaMoneyBill },
  { id: "coupons", name: "Coupons", icon: FaUsers },
  { id: "partners", name: "Partners", icon: FaHandshake },
  { id: "admins", name: "Admins", icon: FaUsers },
  { id: "rentalOptions", name: "Rental Options", icon: FaCog },
];